/**
 * Silent mode for automated testing (`?mute`, kept for the tab in sessionStorage): the app runs
 * exactly as usual, timings included, but nothing reaches the speakers. Web Audio renders to no
 * output device, the browser's speech fallback speaks at volume 0, and media elements play muted.
 * Imported first in main.tsx, before any audio is made.
 */
const KEY = 'foe-names.mute';

function wanted(): boolean {
  try {
    if (new URLSearchParams(window.location.search).has('mute')) {
      sessionStorage.setItem(KEY, '1');
      return true;
    }
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return new URLSearchParams(window.location.search).has('mute');
  }
}

export const MUTED = typeof window !== 'undefined' && wanted();

if (MUTED) {
  // Every AudioContext renders to no output device (Chrome 110+), wherever it is made.
  const Base = window.AudioContext;
  window.AudioContext = class extends Base {
    constructor(options: AudioContextOptions = {}) {
      super({ ...options, sinkId: { type: 'none' } } as AudioContextOptions);
    }
  };
  if ('speechSynthesis' in window) {
    const speak = SpeechSynthesis.prototype.speak.bind(window.speechSynthesis);
    SpeechSynthesis.prototype.speak = (u: SpeechSynthesisUtterance) => {
      u.volume = 0;
      speak(u);
    };
  }
  // eslint-disable-next-line @typescript-eslint/unbound-method -- re-bound below with call()
  const play = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function (this: HTMLMediaElement) {
    this.muted = true;
    return play.call(this);
  };
}
